module.exports = __webpack_public_path__ + "media/home01.85308da2.webm";